<button class="btn-login"
        id="settingsHeader"
        style="cursor: auto">
    Support
</button>
<div class="home">
    <div class="games-menu__body">
        <div class="games-menu__body-inner is-active">
            <div class="games-menu__popup">
                <div class="games-popup">
                    <button (click)="goBack()"
                        class="games-popup__close-btn close-btn">
                        <img src="../../../assets/images/games-playground/close-btn.png"
                             title="Close"
                             alt="Close">
                    </button>

                    <div class="chat-frame" *ngIf="frameUrl">
                        <iframe [src]="frameUrl" frameborder="0"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
